module.exports = __webpack_public_path__ + "img/vol03_cup01_cover01.5ff95041.jpg";